export const types = {
    INIT_TIMELINES: 'init_timelines',
    CHANGE_TIMELINE_VOLUME: 'change_timeline_volume',
    CHANGE_ZOOM: 'change_zoom',
    ADD_AUDIO_TO_TIMELINE: 'add_audio_to_timeline',
    SELECT_ELEMENT: 'select_element',
    CHANGE_ELEMENT_POSITION: 'change_element_position',
    DRAG_AND_CLONE_ELEMENT: 'drag_and_clone_element',
    CHANGE_SOLO: 'change_solo',
    CHANGE_MUTE: 'change_mute',
    DELETE_ITEM: 'detele_item',
    SET_MARKER_POSITION: 'set_marker_position',
    SPLIT_AUDIO: 'split_audio',
    AUDIO_EDITOR_UNDO_REDO: 'audio_editor_undo_redo',
    SET_TIMELINE_WIDTH: 'set_timeline_width',
    UPDATE_ITEM: 'update_item',
    UPDATE_SOUND_DURATION: 'update_sound_duration',
    CHANGE_TITLE: 'change_title',
    SET_VOLUME_POINTS: 'set_volume_points',
    SHOW_TRACK_MENU: 'show_track_menu',
    ADD_TRACK: 'add_track',
    DELETE_TRACK: 'delete_track',
    REFRESH_AUDIO_TRACK: 'refresh_audio_track',
    CHANGE_VOLUME: 'change_volume',
    REFRESH_AUDIO_ELEMENTS: 'refresh_audio_elements',
    MOVE_BLOCK: 'move_block',
    RECORDED_DATA_IOS: 'recorded_data_IOS',
};

export function initTimelines(content) {
    return { type: types.INIT_TIMELINES, content};
}

export function changeTimelineVolume(index, volume) {
    return { type: types.CHANGE_TIMELINE_VOLUME, index, volume};
}

export function changeZoom(value) {
    return { type: types.CHANGE_ZOOM, value};
}

export function addAudioToTimeline(index, audio) {
    return { type: types.ADD_AUDIO_TO_TIMELINE, index, audio};
}

export function selectElement(uuid, value) {
    return { type: types.SELECT_ELEMENT, uuid, value};
}

export function changeElementPosition(properties) {
    return { type: types.CHANGE_ELEMENT_POSITION, properties};
}

export function dragAndCloneElement(properties) {
    return { type: types.DRAG_AND_CLONE_ELEMENT, properties};
}

export function changeSolo(index) {
    return { type: types.CHANGE_SOLO, index};
}

export function changeMute(index) {
    return { type: types.CHANGE_MUTE, index};
}

export function changeVolume(volume) {
    return { type: types.CHANGE_VOLUME, volume};
}

export function deleteItem(uuid) {
    return { type: types.DELETE_ITEM, uuid};
}

export function setMarkerPosition(position) {
    return { type: types.SET_MARKER_POSITION, position};
}

export function splitAudio(audio, markerPosition) {
    return { type: types.SPLIT_AUDIO, audio, markerPosition};
}

export function audioEditorUndoRedo(newState) {
    return { type: types.AUDIO_EDITOR_UNDO_REDO, newState};
}

export function setTimelineWidth(width) {
    return { type: types.SET_TIMELINE_WIDTH, width};
}

export function updateItem(uuids, href) {
    return { type: types.UPDATE_ITEM, uuids, href};
}

export function updateSoundDuration(uuid, duration) {
    return { type: types.UPDATE_SOUND_DURATION, uuid, duration};
}

export function changeTitle(index, title) {
    return { type: types.CHANGE_TITLE, index, title};
}

export function setVolumePoints(uuid, points) {
    return { type: types.SET_VOLUME_POINTS, uuid, points};
}

export function showTrackMenu(value) {
    return { type: types.SHOW_TRACK_MENU, value};
}

export function addTrack(index) {
    return { type: types.ADD_TRACK, index};
}

export function deleteTrack(index) {
    return { type: types.DELETE_TRACK, index};
}

export function refreshAudioTrack(value) {
    return { type: types.REFRESH_AUDIO_TRACK, value};
}

export function refreshAudioElements(value) {
    return { type: types.REFRESH_AUDIO_ELEMENTS, value};
}

export function moveBlock(array, offsetX, indexOffset) {
    return { type: types.MOVE_BLOCK, array, offsetX, indexOffset};
}

export function recordedDataIos(data) {
    return { type: types.RECORDED_DATA_IOS, data};
}



/** WEBPACK FOOTER **
 ** ./src/actions/AudioEditorActions.js
 **/